export const FEE_TYPE = {
  free: 'free',
  condition: 'condition',
  fixed: 'fixed'
}
